const emailValidation = (email, validation) => {
  if (email.length === 0) {
    validation.errors['email'] = 'Please enter email.';
    validation.formIsValid = false;
  }

  if (email.length !== 0) {
    let lastAtPos = email.lastIndexOf('@');
    let lastDotPos = email.lastIndexOf('.');

    if (
      !(
        lastAtPos < lastDotPos &&
        lastAtPos > 0 &&
        email.indexOf('@@') == -1 &&
        lastDotPos > 2 &&
        email.length - lastDotPos > 2
      )
    ) {
      document.getElementById('email').value = '';
      validation.formIsValid = false;
      validation.errors['email'] = 'Email is not valid.';
    }
  }
};

const nameValidation = (name, validation) => {
  if (name.length === 0) {
    validation.errors['name'] = 'Please enter name.';
    validation.formIsValid = false;
  }
};

const firstNameValidation = (name, validation) => {
  if (name.length === 0) {
    validation.errors['first'] = 'Please enter first name.';
    validation.formIsValid = false;
  }
};

const lastNameValidation = (name, validation) => {
  if (name.length === 0) {
    validation.errors['last'] = 'Please enter last name.';
    validation.formIsValid = false;
  }
};

const companyValidation = (company, validation) => {
  if (company.length === 0) {
    validation.errors['company'] = 'Please enter company name.';
    validation.formIsValid = false;
  }
};

const titleValidation = (title, validation) => {
  if (title.length === 0) {
    validation.errors['title'] = 'Please enter organization title.';
    validation.formIsValid = false;
  }
};

const interestsValidation = (interests, validation) => {
  if (interests.length === 0) {
    validation.errors['interests'] = 'Please let us know how we can help you.';
    validation.formIsValid = false;
  }
};

const commentsValidation = (comments, validation) => {
  if (comments.length === 0) {
    validation.errors['comments'] = 'Please enter comments.';
    validation.formIsValid = false;
  }
};

const uploadValidation = (file, validation) => {
  if (typeof file.name === 'undefined') {
    validation.errors['file'] = 'Please upload file.';
    validation.formIsValid = false;
  }
};

export const handleContactValidation = (name, email, interests) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  nameValidation(name, validation);
  emailValidation(email, validation);
  interestsValidation(interests, validation);

  return validation;
};

export const handleEmailValidation = (email) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  emailValidation(email, validation);

  return validation;
};

export const handleConnectValidation = (name, email, company) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  nameValidation(name, validation);
  emailValidation(email, validation);
  companyValidation(company, validation);

  return validation;
};

export const handleWebinarValidation = (first, last, email, company) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  firstNameValidation(first, validation);
  lastNameValidation(last, validation);
  emailValidation(email, validation);
  companyValidation(company, validation);

  return validation;
};

export const handleMeaningfulValidation = (first, last, email) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  firstNameValidation(first, validation);
  lastNameValidation(last, validation);
  emailValidation(email, validation);

  return validation;
};

export const handleEventContactValidation = (name, email) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  nameValidation(name, validation);
  emailValidation(email, validation);

  return validation;
};

export const handleGeneralSubmissionsValidation = (name, email, comments) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  nameValidation(name, validation);
  emailValidation(email, validation);
  commentsValidation(comments, validation);

  return validation;
};

export const handlePositionValidation = (name, email, file) => {
  let validation = {
    errors: {},
    formIsValid: true,
  };

  nameValidation(name, validation);
  emailValidation(email, validation);
  uploadValidation(file, validation);

  return validation;
};



// WEBPACK FOOTER //
// ./src/utils/helper-functions/form-handling.js